import RoundedBoxComponent from "../race/block/RoundedBoxComponent.jsx";
import { COLORS } from "../../constants/colors";

const TrianglePyramid = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  color = COLORS.red,
}) => {
  const baseSize = 5; // Количество кубиков в основании
  const cubeSize = 0.4; // Размер кубика
  const spacing = 0.05; // Расстояние между кубиками
  const radius = 0;
  const totalSize = cubeSize + spacing;

  return (
    <group position={position} rotation={rotation}>
      {Array.from({ length: baseSize }, (_, row) => {
        const cubesInRow = baseSize - row; // Уменьшаем количество кубиков с каждым рядом

        return Array.from({ length: cubesInRow }, (_, col) => (
          <RoundedBoxComponent
            key={`${row}-${col}`}
            position={[(col - cubesInRow / 2) * totalSize, row * totalSize, 0]}
            size={cubeSize}
            radius={radius}
            mass={row === 0 ? 0.5 : 0.0001} // Увеличиваем массу для нижних рядов
            friction={0.9} // Увеличиваем трение
            restitution={0.05} // Уменьшаем упругость
            linearDamping={0.8} // Увеличиваем затухание
            angularDamping={0.9} // Увеличиваем затухание вращения
            color={color}
          />
        ));
      })}
    </group>
  );
};

export default TrianglePyramid;
